import React from 'react';
import PropTypes from 'prop-types';
import styles from './phonepad.css';
import Popover from 'cd-ui-react/components/popover';
import Icon from 'cd-ui-react/components/icon';
import PhoneBook from '../phonebook';
import Spinner from 'cd-ui-react/components/spinner';
import ComponentsUtil, {HttpReasonCodes, KeyCodes} from '../../utils/ComponentsUtil';
import {i18n} from '../../utils/GadgetUtils';

const utilities = window.finesse.utilities.Utilities;

export class PhonePad extends React.Component {
	/*
	 * PhonePad component is the one that encloses the popover, which hosts the KeyPad.
	 * The KeyPad component hosts the button -- Consult / Transfer.
	 * So, when the button is clicked, we initiate the corresponding action, and expect
	 * the popover to close, upon initiating the action.
	 * To realize this, we intercept the phonepadActionCallback prop to KeyPad by
	 * providing our own handler. And, in the handler, we invoke the actual
	 * handler that is passed to us via the phonepadActionCallback prop.
	 * Post that, we call the dismiss to close the popover.
	 *
	 * This way we will be able to achieve the intuitive behavior of closing the popover
	 * upon clicking the button -- similar to how a dialog closes when OK is clicked.
	 */

	constructor (props) {
		super(props);
	}

	handleSubmitAction = (arg) => {
		if (this.props.phonepadActionCallback) {
			this.props.phonepadActionCallback(arg);
		}

		// to close the popover and reset the caller state
		if (this.props.onDismiss) {
			this.props.onDismiss();
		}
	}

	keyDown = e => {
		if (e.keyCode === KeyCodes.KEY_ESC) {
			e.preventDefault();
			setTimeout(() => {
				ComponentsUtil.setFocusByElementID(this.props.id);
			}, 0);
		}
	}

	render () {
		let { show, onDismiss, id, scriptSelectors, transferError, transferErrorCode } = this.props;
		const showloading = scriptSelectors && !scriptSelectors.options && !scriptSelectors.errorMessage;
		return (
			<Popover id={`phonepad-${id}`} className={`${styles.phonepadContainer}`}
				placement="bottom" show={show} target={id} onDismiss={onDismiss} chevron >
				<div onKeyDown={this.keyDown}>
					{showloading ? <div className={`${styles.spinnerContainer}`}> <div className={`${styles.showSpinner} flex justify-content-ce align-item-center`}>
						<Spinner size="large" /> </div></div>
						: <PhoneBook phoneBookData={scriptSelectors} phonepadActionCallback={this.handleSubmitAction} transferError={transferError} transferErrorCode={transferErrorCode}/>
						}
				</div>
				{this.props.mobileAgentInfo &&
					<div className={`flex ${styles.infoContainer}`}>
						<div className={`${styles.infoIcon}`}><Icon name="info" height="17px" width="17px" color="#0ab7d7" /></div>
						<span>
							{i18n.getMsg('gadget.callcontrol.tooltip.mobile.agent.outbound-call')}
						</span>
					</div>
				}
			</Popover>
		);
	}
}

export default PhonePad;

PhonePad.propTypes = {
	/* Flag to indicate whether phonepad is open or closed */
	show: PropTypes.bool.isRequired,
	/* Unique id to generate id of html elements */
	id: PropTypes.string.isRequired,
	/* callback function when clicked outside the phonepad */
	onDismiss: PropTypes.func.isRequired,
	/* Callback function to be invoked when action button is clicked */
	phonepadActionCallback: PropTypes.func.isRequired,

	mobileAgentInfo: PropTypes.bool,

	phoneNumber: PropTypes.string,

	/* This is the session storage key to retrieve the saved number in the dialpad. Keypad appearing in
	call control(consult and transfer) and the header can have different values saved as per the discussion */
	cachedKeypadContentKey: PropTypes.string
};

PhonePad.defaultProps = {
	/* Flag to indicate whether phonepad is open or closed */
	show: false,
	/* Unique id to generate id of html elements */
	id: ''
};
